/**
 * @name: 修改数据字典项
 * @description:
 * @author: Wood
 * @date: 2021/5/23
 * @update:
 */
import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
import {Modal} from 'antd';
import Form, {useForm} from 'form-render';
import FormDataCheck from '../../../components/data/form-data-check';
import {putData} from "../../../lib/api_data";

const schema = {
    "type": "object",
    "properties": {
        "name": {
            "title": "角色名称",
            "required": true,
            "disabled": false,
            "readOnly": false,
            "hidden": false,
            "props": {
                "allowClear": false
            },
            "type": "string"
        },
        "desc": {
            "title": "描述",
            "required": false,
            "disabled": false,
            "readOnly": false,
            "hidden": false,
            "props": {
                "allowClear": false
            },
            "type": "string"
        },
        "order_index": {
            "title": "排序",
            "required": true,
            "disabled": false,
            "readOnly": false,
            "hidden": false,
            "props": {
                "allowClear": false
            },
            "type": "number",
            "min": 0,
        },
        "is_lock": {
            "title": "是否内置",
            "default": 0,
            "required": true,
            "disabled": false,
            "readOnly": false,
            "hidden": false,
            "enum": [
                0,
                1
            ],
            "enumNames": [
                "非内置",
                "内置"
            ],
            "type": "number",
            "widget": "radio"
        },
        "type": {
            "title": "角色类型",
            "default": 0,
            "required": true,
            "disabled": false,
            "readOnly": false,
            "hidden": false,
            "enum": [
                1,
                2,
                3
            ],
            "enumNames": [
                "系统管理员",
                "前台",
                "教练"
            ],
            "type": "number",
            "widget": "radio"
        },
        "status": {
            "title": "状态",
            "default": 0,
            "required": true,
            "disabled": false,
            "readOnly": false,
            "hidden": false,
            "enum": [
                0,
                1
            ],
            "enumNames": [
                "正常",
                "停用"
            ],
            "type": "number",
            "widget": "radio"
        }
    },
    "column": 1,
    "labelWidth": 150,
    "displayType": "row",
    "showDescIcon": true
};


const SysDictEditModal = ({visible, type_id, data, onOk, onCancel}) => {
    const form = useForm();

    const onFinish = (formData, errors) => {
        if (errors.length > 0) {
        } else {
            console.log(formData);
            formData.type_id = type_id;
            formData = {...data, ...formData};
            putData("roles", formData)
                .then(res => {
                    if (res.code === 0) {
                        onOk && onOk(res.data);
                    }
                })
        }
    };

    useEffect(() => {
        form.setValues(data)
    }, []);

    return (
        <Modal
            title="修改角色"
            visible={visible}
            onOk={form.submit}
            onCancel={onCancel}
            width={800}
            destroyOnClose={true}
        >
            <Form
                form={form}
                schema={schema}
                widgets={{FormDataCheck: FormDataCheck}}
                onFinish={onFinish}
                // initialValues={data}
            />
        </Modal>
    )
};

SysDictEditModal.propTypes = {
    visible: PropTypes.bool,
    onCancel: PropTypes.func,
    onOk: PropTypes.func,
    data: PropTypes.object,
    type_id: PropTypes.string,
};

export default SysDictEditModal;
